var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauAlge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9986 11.9611C10.1296 11.9611 8.61445 10.4115 8.61445 8.5C8.61445 6.58853 10.1296 5.03894 11.9986 5.03894C11.9991 5.03894 11.9995 5.03894 12 5.03894V1H1V16H12V11.9611C11.9995 11.9611 11.9991 11.9611 11.9986 11.9611Z",
    fill: "#006233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0977 8.49994C10.0977 9.74914 10.8977 10.8067 12.0016 11.1681V5.83179C10.8972 6.19272 10.0977 7.25073 10.0977 8.49994Z",
    fill: "#006233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1V5.03894C13.1529 5.03941 14.1706 5.62969 14.7814 6.53036C14.2848 6.01732 13.5963 5.69882 12.8345 5.69882C12.5436 5.69882 12.2629 5.74555 12 5.83185V11.1677C12.2634 11.2535 12.5436 11.3007 12.8345 11.3007C13.5963 11.3007 14.2848 10.9827 14.7814 10.4692C14.1706 11.3698 13.1529 11.9601 12 11.9606V15.9995H23V1H12ZM13.8462 8.88907L13.848 10.113L13.1431 9.12413L12.0056 9.50413L12.7072 8.51287L12.0023 7.524L13.1413 7.90019L13.8429 6.90893L13.8448 8.13287L14.9837 8.50906L13.8462 8.88907Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8438 8.88907L14.9814 8.50906L13.8424 8.13287L13.8406 6.90894L13.1389 7.90019L12 7.524L12.7049 8.51288L12.0033 9.50414L13.1408 9.12413L13.8457 10.113L13.8438 8.88907Z",
    fill: "url(#paint0_linear_10403_49067)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 11.3006C11.321 11.3006 10.0949 10.0466 10.0949 8.49989C10.0949 6.95317 11.321 5.69919 12.8333 5.69919C13.5951 5.69919 14.2837 6.01721 14.7802 6.53072C14.1695 5.62958 13.1508 5.03931 11.9974 5.03931C10.1284 5.03931 8.61328 6.58889 8.61328 8.50037C8.61328 10.4118 10.1284 11.9614 11.9974 11.9614C13.1508 11.9614 14.1695 11.3712 14.7802 10.47C14.2837 10.9826 13.5951 11.3006 12.8333 11.3006Z",
    fill: "url(#paint1_linear_10403_49067)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10403_49067",
    x1: 12.0032,
    y1: 7.52203,
    x2: 14.449,
    y2: 9.27299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10403_49067",
    x1: 9.27938,
    y1: 6.43746,
    x2: 14.8011,
    y2: 10.4434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauAlge);
export default __webpack_public_path__ + "static/media/drapeauAlge.0bc4c71749a3fc1a7abe34baaa3cb7b2.svg";
export { ForwardRef as ReactComponent };